import { Start, Stop } from 'smg/buttons';
import * as promos from 'smg/customer-api/promos';
import * as models from 'smg/customer-api/models';
import * as quoterequests from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import { ShowError } from 'smg/errors';
import { BlockPastDates, ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { Uploader } from 'smg/uploads';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
    getStartedSuccess: string;
    reviews: rowsResp;
}

declare interface rowsResp {
    results: row[];
}
declare interface productImage {
    altText: string;
    height: number;
    type: string;
    url: string;
    width: number;
}

declare interface sharedInterface {
    id: string;
    label: string;
    name: string;
    order: number;
    type: string;
}

declare interface values {
    product_image: productImage;
    product_purchased: sharedInterface;
    review_body: string;
    review_source: sharedInterface;
    reviewer_name: string;
    smg_company: sharedInterface;
    stars: sharedInterface;

}

declare interface row {
    childTableId: string;
    createdAt: string;
    id: string;
    isSoftEditable: boolean;
    name: unknown;
    path: unknown;
    publishedAt: string;
    updatedAt: string;
    values: values;
}
declare const window: myWindow;

function show(hiddenParents: HTMLElement[]) {
    hiddenParents.forEach(el => {
        el.classList.remove('d-none');
        const inputs = el.querySelectorAll<HTMLInputElement>('input');
        const selects = el.querySelectorAll<HTMLSelectElement>('select');
        if (inputs) {
            Array.from(inputs).forEach(input => input.setAttribute('required', ''));
        }
        if (selects) {
            Array.from(selects).forEach(select => select.setAttribute('required', ''));
        }
    });
    return;
}

function hide(els: HTMLElement[]) {
    els.forEach(el => {
        el.classList.add('d-none');
        const inputs = el.querySelectorAll<HTMLInputElement>('input');
        const selects = el.querySelectorAll<HTMLSelectElement>('select');
        if (inputs) {
            Array.from(inputs).forEach(input => {
                input.removeAttribute('required');
                if (input.checked) {
                    input.checked = false;
                }
            });
        }
        if (selects) {
            Array.from(selects).forEach(select => {
                select.removeAttribute('required');
                Array.from(select.querySelectorAll<HTMLOptionElement>('option')).forEach((el, i) => {
                    if (i === 0) {
                        el.selected = true;
                    } else {
                        el.selected = false;
                    }
                });
            });
        }
    });
}

main();

function main() {
    const fieldset = document.querySelector('#fieldset') as HTMLFieldSetElement;
    const form = document.querySelector('#get-started-form') as HTMLFormElement;
    const product = form.querySelector('#product') as HTMLSelectElement;
    const edgeTypeParent = form.querySelector('.edge-type-parent') as HTMLElement;
    const enamelColorsParent = form.querySelector('.enamel-colors-parent') as HTMLElement;
    const beltBuckleAttachmentStyleParent = form.querySelector('.belt-style') as HTMLElement;
    const platingStyleParent = form.querySelector('.plating-style') as HTMLElement;
    const sizeParent = form.querySelector('.size-parent') as HTMLElement;
    const size = form.querySelector('#size') as HTMLSelectElement;
    const quantity = form.querySelector('#quantity') as HTMLInputElement;
    const projectName = form.querySelector('#project_name') as HTMLInputElement;
    const budget = form.querySelector('#budget') as HTMLInputElement;
    const deadlineParent = form.querySelector('.deadline-parent') as HTMLElement;
    const dateNeededParent = form.querySelector('.date-needed') as HTMLElement;
    const date = dateNeededParent.querySelector('input') as HTMLInputElement;
    const revalidateDate = BlockPastDates(date, { earliest: 'tomorrow' });
    const upload = form.querySelector('#upload') as HTMLLabelElement;
    const projectNotes = form.querySelector('#project-notes') as HTMLTextAreaElement;
    const firstName = form.querySelector('#firstname') as HTMLInputElement;
    const lastName = form.querySelector('#lastname') as HTMLInputElement;
    const email = form.querySelector('#email') as HTMLInputElement;
    const phone = form.querySelector('#phone') as HTMLInputElement;
    const promoCode = form.querySelector('#promo_code') as HTMLInputElement;
    const submit = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const minQty = form.querySelector('.min-qty') as HTMLElement;

    const p = new Phone(phone);
    const promoInput = new promos.Input(promoCode, { $email: email });
    const u = new Uploader(upload);

    function check(product: string): HTMLElement[] {
        switch (product) {
        case 'Challenge Coins':
            return [edgeTypeParent, enamelColorsParent, platingStyleParent, sizeParent];
        case 'Bottle Openers':
            return [enamelColorsParent, platingStyleParent, sizeParent];
        case 'Dog Tags':
            return [enamelColorsParent, platingStyleParent, sizeParent];
        case 'Belt Buckles':
            return [enamelColorsParent, beltBuckleAttachmentStyleParent, platingStyleParent, sizeParent];
        case 'Lapel Pins':
            return [platingStyleParent, sizeParent];
        case 'Trading Pins':
        case 'Patches':
            return [sizeParent];
        default:
            return [];
        }
    }

    function getLineItemChildren(product: string, form: HTMLFormElement): models.QuoteRequestCreateChild[] {
        const arr: models.QuoteRequestCreateChild[] = [];
        const checkedEnamelRadio = Array.from(enamelColorsParent.querySelectorAll<HTMLInputElement>('input')).filter(input => input.checked === true);
        const platingStyle = form.querySelector<HTMLSelectElement>('#plating_style')?.value;
        switch (product) {
        case 'Challenge Coins': {
            const edgeType = new models.QuoteRequestCreateChild({
                child: 'Edge',
                option: form.querySelector<HTMLSelectElement>('#edge_type')?.value,
            });
            const coinPlatingStyle = new models.QuoteRequestCreateChild({
                child: 'Plating',
                option: platingStyle,
            });
            arr.push(edgeType, coinPlatingStyle);
            return arr;
        }
        case 'Bottle Openers': {
            const bottlePlatingStyle = new models.QuoteRequestCreateChild({
                child: 'Plating',
                option: platingStyle,
            });
            arr.push(bottlePlatingStyle);
            return arr;
        }
        case 'Dog Tags': {
            const dogEnamelColors = new models.QuoteRequestCreateChild({
                child: checkedEnamelRadio[0].value,
            });
            const dogPlatingStyle = new models.QuoteRequestCreateChild({
                child: 'Plating',
                option: platingStyle,
            });
            arr.push(dogEnamelColors, dogPlatingStyle);
            return arr;
        }
        case 'Belt Buckles': {
            const beltEnamelColors = new models.QuoteRequestCreateChild({
                child: checkedEnamelRadio[0].value,
            });
            const beltPlatingStyle = new models.QuoteRequestCreateChild({
                child: 'Plating',
                option: platingStyle,
            });
            const beltCheckedAttachmentRadio = Array.from(beltBuckleAttachmentStyleParent.querySelectorAll<HTMLInputElement>('input')).filter(input => input.checked === true);
            const attachmentStyle = new models.QuoteRequestCreateChild({
                child: 'Belt Buckle Attachment Style',
                option: beltCheckedAttachmentRadio[0].value,
            });
            arr.push(beltEnamelColors, beltPlatingStyle, attachmentStyle);
            return arr;
        }
        case 'Lapel Pins': {
            const pinPlatingStyle = new models.QuoteRequestCreateChild({
                child: 'Plating',
                option: platingStyle,
            });
            arr.push(pinPlatingStyle);
            return arr;
        }
        }
        return [];
    }

    function getType(parent: HTMLElement): string {
        const checkedEnamelRadio = Array.from(parent.querySelectorAll<HTMLInputElement>('input')).filter(input => input.checked === true);
        return checkedEnamelRadio[0].value;
    }

    function changeMinimumQty() {
        const select = product.value;
        switch (select) {
        case 'Challenge Coins':
            minQty.textContent = '50';
            break;
        case 'Belt Buckles':
            minQty.textContent = '25';
            break;
        default:
            minQty.textContent = '100';
        }
    }

    window.addEventListener('load', () => {
        if (product.value !== '') {
            show(check(product.value));
            product.options.selectedIndex = 0;
        }
    });

    product.addEventListener('change', () => {
        hide([edgeTypeParent, enamelColorsParent, beltBuckleAttachmentStyleParent, platingStyleParent, sizeParent]);
        show(check(product.value));
        changeMinimumQty();
    });

    deadlineParent.addEventListener('click', function () {
        if (this.querySelector<HTMLInputElement>('#yes-deadline')?.checked) {
            show([dateNeededParent]);
        } else {
            hide([dateNeededParent]);
            // hide() only drops `required` — the input stays enabled, so a date
            // typed before switching to "no deadline" would still ride along on
            // the quote request and could block submit with an unseen error.
            date.value = '';
            revalidateDate();
        }
    });

    form.noValidate = true;
    form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const smsOptIn = this.querySelector<HTMLInputElement>('#sms-opt-in')?.checked;

        await promoInput.check();

        if (!ReportValidity(form)) {
            return false;
        }

        Start(submit);
        fieldset.disabled = true;

        // Awaited outside the chain — a PUT-failure throw would otherwise skip
        // the catch below and leave the form disabled.
        let uploadIDs: number[];
        try {
            uploadIDs = await u.getUploadIDs();
        } catch (err) {
            ShowError(err);
            fieldset.disabled = false;
            Stop(submit);
            return;
        }

        void quoterequests.NewQuoteRequest({
            form: 'get started',
            name: `${firstName.value} ${lastName.value}`,
            company: '',
            phone: await p.format(),
            email: email.value,
            promo: promoCode.value,
            sms: smsOptIn,
            lineItem: product.value,
            type: product.value === 'Challenge Coins' || product.value === 'Bottle Openers' ? getType(enamelColorsParent) : '',
            children: getLineItemChildren(product.value, this),
            size: size.value,
            quantity: parseInt(quantity.value, 10),
            project: projectName.value ?? '',
            budget: parseFloat(budget.value) || undefined,
            dateNeeded: date.value ?? '',
            uploadIDs,
            notes: projectNotes.value,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'dod-freequote-submission',
                'userData': {
                    'email': sess?.user.emailAddress.email || email.value,
                    'phone': sess?.user.phoneNumber.phone || await p.format(),
                    'firstName': sess?.user.firstName || firstName.value,
                    'lastName': sess?.user.lastName || lastName.value,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });

            window.location.href = String(window.getStartedSuccess);
        }).catch(err => {
            fieldset.disabled = false;
            Stop(submit);
            throw err;
        });
    });
}
